import { render, staticRenderFns } from "./NotificationUploadFilesDoc.vue?vue&type=template&id=10314f35"
import script from "./NotificationUploadFilesDoc.vue?vue&type=script&lang=js"
export * from "./NotificationUploadFilesDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationUploadFilesDoc.vue?vue&type=style&index=0&id=10314f35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports